export default{STEPS:['confirmation','follow-up-report','documents']};